module.exports = __webpack_public_path__ + "media/dashboard/assets/images/thank_cuppo-1ad8c7d9b2e91de7952aa367f9755868.svg";